import { useQuery } from 'react-query';
import FeatureFlagsApi from '../FeatureFlagsApi';
import { FeatureFlagOptions } from '../types';

export const featureFlagOptionsQueryKey = 'feature-flag-options';

export function useFeatureFlagOptionsQuery() {
    return useQuery<FeatureFlagOptions>(
        [featureFlagOptionsQueryKey],
        () => FeatureFlagsApi.options(),
        {
            staleTime: 5 * 60 * 1000,
            refetchOnWindowFocus: false
        }
    );
}
